import React from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { config } from '../_helpers';
import { accountService, alertService } from '../_services';

function ForgotPassword() {
    const initialValues = {
        email: ''
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email('Email is invalid')
            .required('Email is required')
    });

    function onSubmit({ email }, { setSubmitting }) {
        alertService.clear();
        accountService.forgotPassword(email)
            .then(() => alertService.success('Please check your email for password reset instructions'))
            .catch(error => alertService.error(error))
            .finally(() => setSubmitting(false));
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting }) => (
                <Form>
                    <h5 className="card-header">Forgot Password</h5>
                    
                    <div className="form-group">
                        <label>Email Address</label>
                        <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} placeholder="Enter your email" />
                        <ErrorMessage name="email" component="div" className="invalid-feedback" />
                    </div>
                    
                    <div className="form-group">
                        <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                            {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                            Send Reset Link
                        </button>
                    </div>

                    <div className="form-group d-flex justify-content-center align-items-center mt-4">
                        <Link to="login" className="btn btn-link p-0">
                            Back to Sign In
                        </Link>
                    </div>

                    <div style={{ fontSize: "0.7em", color: "#666", textAlign: "center", marginTop: "30px" }}>
                        <span>&#169;</span>{new Date().getFullYear() + " " + config.Provider}. All Rights Reserved.
                    </div>
                </Form>
            )}
        </Formik>        
    )
}

export { ForgotPassword };